export * from './ChessBoardWrapper';
export { default } from './ChessBoardWrapper';
